(function () {
    'use strict';
    /* jshint -W071, -W074 */

    angular
        .module('blocks.smart')
        .filter('selectFilter', selectFilter);

    /* @ngInject */
    function selectFilter($filter) {
        // allows us to have a select filter on smart tables.
        // Usage:
        //  <smart-select collection="vm.someCollection"></smart-select>
        // Creates:
        //  <smart-select collection="vm.someCollection">
        //  <select><select>
        //  </smart-select>
        var filterFilter = $filter('filter');
        var standardComparator = function standardComparator(obj, text) {
            text = ('' + text).toLowerCase();
            return ('' + obj).toLowerCase().indexOf(text) > -1;
        };

        return function customFilter(array, expression) {
            var output = filterFilter(array, expression, customComparator);
            return output;
        };

        function customComparator(actual, expected) {
            if (angular.isObject(expected)) {
                return checkExpectedResult();
            }
            return standardComparator(actual, expected);
        }

        function checkExpectedResult(actual, expected) {
            //exact match
            if (expected.distinct) {
                return checkDistinct(actual, expected);
            }
            //matchAny
            if (expected.matchAny) {
                return checkMatchAny(actual, expected);
            }
            //date range
            if (expected.before || expected.after) {
                return checkDateRange(actual, expected);
            } else if (expected.lower || expected.higher) {
                return checkNumberRange(actual, expected);
            }
            //etc
            return true;
        }

        function checkDistinct(actual, expected) {
            if (!actual || actual.toLowerCase() !== expected.distinct.toLowerCase()) {
                return false;
            }
            return true;
        }

        function checkMatchAny(actual, expected) {
            if (expected.matchAny.all) {
                return true;
            }

            if (!actual) {
                return false;
            }

            for (var i = 0; i < expected.matchAny.items.length; i++) {
                if (actual.toLowerCase() === expected.matchAny.items[i].toLowerCase()) {
                    return true;
                }
            }

            return false;
        }

        function checkDateRange(actual, expected) {
            var higherLimit,
                lowerLimit,
                itemDate,
                queryDate;
            var isBeforeActivated = expected.before;
            var isAfterActivated = expected.after;

            try {
                if (isBeforeActivated) {
                    higherLimit = expected.before;

                    itemDate = new Date(actual);
                    queryDate = new Date(higherLimit);

                    if (itemDate > queryDate) {
                        return false;
                    }
                }

                if (isAfterActivated) {
                    lowerLimit = expected.after;

                    itemDate = new Date(actual);
                    queryDate = new Date(lowerLimit);

                    if (itemDate < queryDate) {
                        return false;
                    }
                }

                return true;
            } catch (e) {
                return false;
            }
        }

        function checkNumberRange(actual, expected) {
            var higherLimit,
                lowerLimit;
            var isLower = expected.lower;
            var isHigher = expected.higher;
            //number range
            if (isLower) {
                higherLimit = expected.lower;

                if (actual > higherLimit) {
                    return false;
                }
            }

            if (isHigher) {
                lowerLimit = expected.higher;
                if (actual < lowerLimit) {
                    return false;
                }
            }

            return true;
        }
    }
})();

